import { ISurvey } from "../../EnterpriseGPTApi/EnterpriseGPTApiV1Client";
import { SurveyAction } from "../actions/surveyAction";

export const surveyReducer = (survey: ISurvey | undefined, action: SurveyAction): ISurvey | undefined => {
    switch (action.type) {
        case 'SET_SURVEY':
            return action.payload ? { ...action.payload } : undefined;
        case 'RESET_SURVEY':
            return undefined;
        default:
            return survey;
    }
};
